import { setTerm } from './helpers';

export const setDiscountMortgage = setTerm('is_discount_mortgage');
